/* eslint-disable no-undef */
// @ts-nocheck

let commonAnalyticsData;
const createBody = (data?) => {
  let productObj = {
    Products: commonAnalyticsData?.products,
    'Product ID': commonAnalyticsData.pidArr,
    'Product Name': commonAnalyticsData.product_name_array,
    'Product Quantity': commonAnalyticsData.products.map((a) => a['Product Quantity']),
    'Product Variant ID': commonAnalyticsData.products.map((a) => a['Product Variant Id']),
    'Product Price': commonAnalyticsData.products.map((a) => a['Product Price']),
    'Product Image URL': commonAnalyticsData.imgUrlArr,
    'Product Url': commonAnalyticsData.products.map((a) => a['Product Url']),
    ...data,
  };
  return productObj;
};

export const callShopifyAnalytics = (eventName, data) => {
  data?.commonAnalyticsData && (commonAnalyticsData = data.commonAnalyticsData);
  if (eventName === 'checkoutStarted') {
    shopifyAnalyticsCheckoutStarted(data);
  } else if (eventName === 'mobileAddedGK') {
    shopifyAnalyticsMobileAdded(data);
  } else if (eventName === 'addressAdded') {
    shopifyAnalyticsAddressAdded(data);
  } else if (eventName === 'addressStep') {
    shopifyAnalyticsAddressStep(data);
  } else if (eventName === 'paymentStep') {
    shopifyAnalyticsPaymentStep(data);
  } else if (eventName === 'paymentMethod') {
    shopifyAnalyticsPaymentMethod(data);
  } else if (eventName === 'orderPlaced') {
    shopifyAnalyticsPaymentCompleted(data);
  } else if (eventName === 'coupon_applied_success') {
    couponAppliedSuccess(data);
  } else if (eventName === 'coupon_applied_failed') {
    couponAppliedFailed(data);
  }
};

const shopifyAnalyticsCheckoutStarted = (data) => {
  let dataObj = {
    eventName: 'Started_Checkout_GK',
    data: {
      Tag: 'GoKwik Checkout',
      total_price: +data.commonAnalyticsData?.cart_total_price,
      'Original Cart Price': commonAnalyticsData?.cart_after_discount,
      currency: 'INR',
      'Coupon Code': data.commonAnalyticsData.coupon || '',
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      'Total Discount Applied': data.discountAmount ?? 0,
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
      ...createBody(),
    },
  };
  fireShopifyAnalyticsEvents(dataObj.eventName, dataObj.data);
};
const shopifyAnalyticsMobileAdded = (data) => {
  let dataObj = {
    eventName: 'Mobile_Added_GK',
    data: {
      Tag: 'GoKwik Checkout',
      total_price: +data.commonAnalyticsData?.cart_total_price,
      'Original Cart Price': commonAnalyticsData?.cart_after_discount,
      currency: 'INR',
      'Coupon Code': data.commonAnalyticsData?.coupon || '',
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      'Total Discount Applied': data.discountAmount || 0,
      'Mobile Number': `+91${data.evt?.phoneNumber}`,
      'Abandoned URL': data.abcURL,
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
      ...createBody(),
    },
  };
  fireShopifyAnalyticsEvents(dataObj.eventName, dataObj.data);
};
const shopifyAnalyticsAddressAdded = (data) => {
  let dataObj = {
    eventName: 'Address_Added_GK',
    data: {
      Tag: 'GoKwik Checkout',
      total_price: +data.commonAnalyticsData?.cart_total_price,
      'Original Cart Price': commonAnalyticsData?.cart_after_discount,
      currency: 'INR',
      'Coupon Code': data.commonAnalyticsData.coupon || '',
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      'Total Discount Applied': data.discountAmount,
      'Abandoned URL': data.abcURL,
      'Mobile Number': `+91${data?.phoneNumber}`,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Country: 'India',
      Region: data.userAddress?.city,
      Pincode: data.userAddress?.pincode,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Shipping Price': data.shippingCharge,
      'Gokwik Prefilled Address': data.gokwikPrefilledAddress,
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
      ...createBody(),
    },
  };
  fireShopifyAnalyticsEvents(dataObj.eventName, dataObj.data);
};
const shopifyAnalyticsAddressStep = (data) => {
  let dataObj = {
    eventName: 'Address_Step_Reached_GK',
    data: {
      Tag: 'GoKwik Checkout',
      total_price: +data.commonAnalyticsData?.cart_total_price,
      'Original Cart Price': commonAnalyticsData?.cart_after_discount,
      currency: 'INR',
      'Coupon Code': data.commonAnalyticsData.coupon || '',
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      'Total Discount Applied': data.discountAmount,
      'Mobile Number': `+91${data?.phoneNumber}`,
      'Abandoned URL': data.abcURL,
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
      ...createBody(),
    },
  };
  fireShopifyAnalyticsEvents(dataObj.eventName, dataObj.data);
};
const shopifyAnalyticsPaymentStep = (data) => {
  let dataObj = {
    eventName: 'Payment_Step_Reached_GK',
    data: {
      Tag: 'GoKwik Checkout',
      total_price: +data.commonAnalyticsData?.cart_total_price,
      'Original Cart Price': commonAnalyticsData?.cart_after_discount,
      currency: 'INR',
      'Coupon Code': data.commonAnalyticsData.coupon || '',
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      'Total Discount Applied': data.discountAmount,
      'Abandoned URL': data.abcURL,
      'Mobile Number': `+91${data?.phoneNumber}`,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Country: 'India',
      Region: data.userAddress?.city,
      Pincode: data.userAddress?.pincode,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Shipping Price': data.shippingCharge,
      'Gokwik Prefilled Address': data.gokwikPrefilledAddress,
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
      ...createBody(),
    },
  };
  fireShopifyAnalyticsEvents(dataObj.eventName, dataObj.data);
};
const shopifyAnalyticsPaymentMethod = (data) => {
  let dataObj = {
    eventName: 'Payment_Method_Selected_GK',
    data: {
      Tag: 'GoKwik Checkout',
      total_price: +data.commonAnalyticsData?.cart_total_price,
      'Original Cart Price': commonAnalyticsData?.cart_after_discount,
      currency: 'INR',
      'Coupon Code': data.commonAnalyticsData.coupon || '',
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      'Total Discount Applied': data.discountAmount,
      'Abandoned URL': data.abcURL,
      'Mobile Number': `+91${data?.phoneNumber}`,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Country: 'India',
      Region: data.userAddress?.city,
      Pincode: data.userAddress?.pincode,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment method': data.evt.paymentMethod,
      'Shipping Price': data.shippingCharge,
      'Gokwik Prefilled Address': data.gokwikPrefilledAddress,
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
      ...createBody(),
    },
  };
  fireShopifyAnalyticsEvents(dataObj.eventName, dataObj.data);
};
const shopifyAnalyticsPaymentCompleted = (data) => {
  let dataObj = {
    eventName: 'Order_Placed_GK',
    data: {
      Tag: 'GoKwik Checkout',
      total_price: +data.commonAnalyticsData?.cart_total_price,
      'Original Cart Price': commonAnalyticsData?.cart_after_discount,
      currency: 'INR',
      'Coupon Code': data.commonAnalyticsData.coupon || '',
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      'Total Discount Applied': data.discountAmount,
      'Abandoned URL': data.abcURL,
      'Mobile Number': `+91${data?.phoneNumber}`,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Country: 'India',
      Region: data.userAddress?.city,
      Pincode: data.userAddress?.pincode,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Shipping Price': data.shippingCharge,
      'Payment method': data.paymentMethod,
      'Gift Card and Rewards Used': data.priceBreakup?.gift_card_and_reward || 0,
      'Cod Charges': data?.commonAnalyticsData?.codCharges || 0,
      tax: 0,
      'Order Number': data?.orderName,
      'Order Id': data.moid,
      'Gokwik Prefilled Address': data.gokwikPrefilledAddress,
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
      ...createBody(),
    },
  };
  fireShopifyAnalyticsEvents(dataObj.eventName, dataObj.data);
};
const couponAppliedSuccess = (data) => {
  let dataObj = {
    eventName: 'Coupon_Applied_Success_GK',
    data: {
      Tag: 'GoKwik Checkout',
      coupon_code: data?.evt?.coupon_code,
      amount_saved: data?.evt?.amount_saved,
      cart_subtotal: data?.evt?.cart_subtotal,
      checkout_step: data?.evt?.checkout_step,
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
    },
  };
  fireShopifyAnalyticsEvents('Coupon_Applied_Success_GK', dataObj);
};
const couponAppliedFailed = (data) => {
  let dataObj = {
    eventName: 'Coupon_Applied_Failed_GK',
    data: {
      Tag: 'GoKwik Checkout',
      coupon_code: data?.evt?.coupon_code,
      cart_subtotal: data?.evt?.cart_subtotal,
      checkout_step: data?.evt?.checkout_step,
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'],
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'],
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'],
      shopify_session_id: data?.shopifySessionId,
      'Time Stamp': data?.timestamp,
    },
  };
  fireShopifyAnalyticsEvents('Coupon_Applied_Failed_GK', dataObj);
};

const fireShopifyAnalyticsEvents = (eventname, data) => {
  window.Shopify &&
    window.Shopify.analytics &&
    window.Shopify.analytics.publish('gokwik_events', { name: eventname, data: { data } });
};
